import { deserialize, Field, Model } from 'serialize-ts';
import { ProductIndexPrice } from '~app/modules/product/models/product-index-price.model';

@Model()
export class Price {
  @Field()
  amount: number;

  @Field()
  currency: string;
}

@Model()
export class PriceItem {
  @Field()
  vatIncluded: Price;

  @Field()
  vatExcluded: Price;

  @Field()
  vatValue: number;

  
  public static mapPriceItem(productIndexPrice: ProductIndexPrice): PriceItem {
    return deserialize({
      vatIncluded: deserialize({
        amount: Number(productIndexPrice.gross),
        currency: productIndexPrice.currency
      }, Price),
      vatExcluded: deserialize({
        amount: Number(productIndexPrice.net),
        currency: productIndexPrice.currency
      }, Price),
      vatValue: Number(productIndexPrice.vatRate)
    }, PriceItem);
  }
}

@Model()
export class UnitPrice {
  @Field()
  price: PriceItem;

  @Field()
  unitType: number;
}
